(() => {
  // src/js/shop-the-room.js
  function ShopTheRoom() {
    function init() {
      document.querySelectorAll(".ShopTheRoom").forEach((shopTheRoomSection) => {
        const mobileProductsContainer = shopTheRoomSection.querySelector(".ShopTheRoom__MobileProducts");
        const products = document.querySelectorAll(".ShopTheRoom__Product");
        const flickityInstance = Flickity.data(`#${shopTheRoomSection.getAttribute("id")} .Carousel`);
        if (products.length > 0 && mobileProductsContainer && flickityInstance) {
          flickityInstance.on("staticClick", (event, pointer, cellElement, cellIndex) => {
            const product = event.target.closest(".ShopTheRoom__Product");
            if (product) {
              event.preventDefault();
              if (product.classList.contains("ShopTheRoom__Product--active")) {
                mobileProductsContainer.innerHTML = "";
                shopTheRoomSection.querySelectorAll(".ShopTheRoom__Product--active").forEach((oldActive) => {
                  oldActive.classList.remove("ShopTheRoom__Product--active");
                });
              } else {
                shopTheRoomSection.querySelectorAll(".ShopTheRoom__Product--active").forEach((oldActive) => {
                  oldActive.classList.remove("ShopTheRoom__Product--active");
                });
                product.classList.add("ShopTheRoom__Product--active");
                const productItem = product.querySelector(".ProductItem");
                mobileProductsContainer.innerHTML = productItem.outerHTML;
                document.dispatchEvent(new CustomEvent("theme:products:reloaded"));
              }
            }
          });
        } else if (products.length > 0 && mobileProductsContainer) {
          products.forEach((product) => {
            product.addEventListener("click", (event) => {
              event.preventDefault();
              if (product.classList.contains("ShopTheRoom__Product--active")) {
                mobileProductsContainer.innerHTML = "";
                shopTheRoomSection.querySelectorAll(".ShopTheRoom__Product--active").forEach((oldActive) => {
                  oldActive.classList.remove("ShopTheRoom__Product--active");
                });
              } else {
                shopTheRoomSection.querySelectorAll(".ShopTheRoom__Product--active").forEach((oldActive) => {
                  oldActive.classList.remove("ShopTheRoom__Product--active");
                });
                product.classList.add("ShopTheRoom__Product--active");
                const productItem = product.querySelector(".ProductItem");
                mobileProductsContainer.innerHTML = productItem.outerHTML;
                document.dispatchEvent(new CustomEvent("theme:products:reloaded"));
              }
            });
          });
        }
      });
    }
    init();
  }
  document.addEventListener("DOMContentLoaded", () => {
    ShopTheRoom();
  });
})();
